<header>
 <app-header></app-header>
</header>
<div class="main-wrapper" [ngClass]="{'root': flagCenterComponenet}"> 
  <!--  -->
  <div class="side-menu">
  <div class="menu">
    <app-side-menu ></app-side-menu> 
  </div>


  <app-support *ngIf="!hideMenuSide"></app-support>
</div>
  <section class="main-section" [ngClass]="{'center-main':hideMenuSide}" >
    <div class="route-outlet-wrapper">
      <app-container [paddingValues]='"39px 33px"'>
    <router-outlet  (activate)='onActivate($event.constructor.name)'></router-outlet>
    </app-container> 
  </div>
    <app-questions-and-answers *ngIf="!hideQuestions"></app-questions-and-answers>
    <app-articles></app-articles>
  </section>
  <app-logout-message *ngIf="showLogoutMessage" (closePopup)="closePopup()" (logout)="logout()" >
</app-logout-message>
</div>
<app-footer *ngIf="!hideFooter"></app-footer>
<div class="phoneSupport" *ngIf="moeLogin"><span class="textSupport">מרכז סיוע</span> {{phoneSupportMoe}}</div>
    <!-- & onSubmit($event) -->  
    <form id="IDPLogin" name="IDPLogin" #myFormPost enctype="application/x-www-form-urlencoded" method="POST" action={{varAction}} AUTOCOMPLETE="off">
      <input type="hidden" name="option" value="credential" />
      <input type="hidden" id="target" name="target" value={{varTarget}}/>
  </form>